/* eslint-disable react/jsx-filename-extension */
// Shared by gatsby-ssr.js and gatsby-browser.js so the SSR and client
// trees stay identical — divergence between them causes hydration
// mismatches.
import React from "react";
import { Helmet } from "react-helmet";

import VatsimEventsProvider from "./context/VatsimEvents";
import ThemeProvider from "./context/Theme";
import { GlobalStyle } from "./styles";

export const wrapPageElement = ({ element }) => (
  <>
    <GlobalStyle />
    {element}
  </>
);

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    <VatsimEventsProvider>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      {element}
    </VatsimEventsProvider>
  </ThemeProvider>
);
